import { apiClient } from './client';
import { SaleMandate, PaginatedResponse, SaleMandatesListParams } from '../types';

export async function getSaleMandates(params: SaleMandatesListParams = {}): Promise<PaginatedResponse<SaleMandate>> {
  const { data } = await apiClient.get<PaginatedResponse<SaleMandate>>('/sale-mandates', { params });
  return data;
}

export async function getSaleMandate(id: string): Promise<{ data: SaleMandate }> {
  const { data } = await apiClient.get<{ data: SaleMandate }>(`/sale-mandates/${id}`);
  return data;
}

export async function createSaleMandate(payload: Partial<SaleMandate>): Promise<{ data: SaleMandate }> {
  const { data } = await apiClient.post<{ data: SaleMandate }>('/sale-mandates', payload);
  return data;
}

export async function updateSaleMandate(id: string, payload: Partial<SaleMandate>): Promise<{ data: SaleMandate }> {
  const { data } = await apiClient.put<{ data: SaleMandate }>(`/sale-mandates/${id}`, payload);
  return data;
}

export async function deleteSaleMandate(id: string): Promise<void> {
  await apiClient.delete(`/sale-mandates/${id}`);
}

import type { MatchSettings } from './settings';
export async function getMandateMatchOverride(id: string): Promise<{ override: Partial<MatchSettings> | null; system_defaults: MatchSettings }> {
  const { data } = await apiClient.get(`/sale-mandates/${id}/match-override`);
  return data.data;
}
export async function saveMandateMatchOverride(id: string, override: Partial<MatchSettings> | null): Promise<void> {
  await apiClient.patch(`/sale-mandates/${id}/match-override`, { override });
}

export async function extractMandateFromPdf(file: File): Promise<{ data: SaleMandate; confidence: number }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<{ data: SaleMandate; confidence: number }>(
    '/pdf/extract-mandate',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function extractMandateFromVerkaufsinfo(file: File): Promise<{ data: SaleMandate; confidence: number }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<{ data: SaleMandate; confidence: number }>(
    '/pdf/extract-verkaufsinfo',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function getSaleMandateSendings(id: string): Promise<{ data: import('../types').ExposeSending[] }> {
  const { data } = await apiClient.get(`/sale-mandates/${id}/sendings`);
  return data;
}

export async function updateSaleMandateStatus(id: string, status: string): Promise<void> {
  await apiClient.patch(`/sale-mandates/${id}/status`, { status });
}

export async function updateMandateTeamContacts(
  mandateId: string,
  teamMemberIds: string[],
  roles?: Record<string, string>
): Promise<void> {
  await apiClient.put(`/sale-mandates/${mandateId}/team-contacts`, { team_member_ids: teamMemberIds, roles });
}
